export default {
  startsWith: "Inocie com",
  contains: "Contenha",
  notContains: "Não contenha",
  endsWith: "Termine com",
  equals: "Seja igual",
  notEquals: "Não seja igual",
  noFilter: "Sem filtro",
  in: "Inclui",
  lt: "Menor que",
  lte: "Menor que ou igual a",
  gt: "Maior que",
  gte: "Maior que ou igual a",
  dateIs: "Data é",
  dateIsNot: "Data não é",
  dateBefore: "Data anterior",
  dateAfter: "Data posterior",
  clear: "Limpar",
  apply: "Aplicar",
  matchAll: "Corresponder a todos",
  matchAny: "Corresponder a qualquer",
  addRule: "Adicionar regra",
  removeRule: "Remover regra",
  accept: "Aceitar",
  reject: "Rejeitar",
  choose: "Escolher",
  upload: "Carregar",
  cancel: "Cancelar",
  dayNames: [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
  ],
  dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Se", "Sa"],
  monthNames: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
  monthNamesShort: [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ],
  today: "Hoje",
  weekHeader: "Semana",
  firstDayOfWeek: 0,
  dateFormat: "dd/mm/yy",
  weak: "Semana",
  medium: "Médio",
  strong: "Forte",
  passwordPrompt: "Insira uma senha",
  emptyFilterMessage: "Sem resultados",
  emptyMessage: "Sem opções",
  aria: {
    trueLabel: "True",
    falseLabel: "False",
    nullLabel: "Not Selected",
    star: "1 star",
    stars: "{star} stars",
    selectAll: "Todos os itens selecionados",
    unselectAll: "Todos os itens desselecionados",
    close: "Close",
  },
}
